import * as yup from 'yup';

export const districtCreateSchema = yup.object({
  name: yup
    .string()
    .required('District name is required')
    .min(2, 'District name must be at least 2 characters')
    .max(100, 'District name must be no more than 100 characters'),
  
  code: yup
    .string()
    .required('District code is required')
    .min(2, 'District code must be at least 2 characters')
    .max(20, 'District code must be no more than 20 characters')
    .matches(/^[A-Z0-9-_]+$/, 'District code must contain only uppercase letters, numbers, hyphens, and underscores'),
  
  state: yup
    .string()
    .required('State is required')
    .min(2, 'State must be at least 2 characters')
    .max(50, 'State must be no more than 50 characters'),
  
  country: yup
    .string()
    .required('Country is required')
    .min(2, 'Country must be at least 2 characters')
    .max(100, 'Country must be no more than 100 characters'),
  
  city: yup
    .string()
    .max(100, 'City must be no more than 100 characters'),
  
  zip_code: yup
    .string()
    .matches(/^\d{5}(-\d{4})?$/, 'Please enter a valid zip code (e.g., 12345 or 12345-6789)')
    .max(10, 'Zip code must be no more than 10 characters'),
  
  superintendent: yup
    .string()
    .max(200, 'Superintendent name must be no more than 200 characters'),
  
  email: yup
    .string()
    .email('Please enter a valid email address')
    .max(100, 'Email must be no more than 100 characters'),
  
  phone: yup
    .string()
    .matches(/^[+]?[1-9]\d{0,15}$/, 'Please enter a valid phone number')
    .max(20, 'Phone number must be no more than 20 characters'),
  
  address: yup
    .string()
    .max(500, 'Address must be no more than 500 characters'),
  
  website: yup
    .string()
    .url('Please enter a valid website URL')
    .max(255, 'Website URL must be no more than 255 characters'),
});

export const districtUpdateSchema = yup.object({
  name: yup
    .string()
    .min(2, 'District name must be at least 2 characters')
    .max(100, 'District name must be no more than 100 characters'),
  
  code: yup
    .string()
    .min(2, 'District code must be at least 2 characters')
    .max(20, 'District code must be no more than 20 characters')
    .matches(/^[A-Z0-9-_]+$/, 'District code must contain only uppercase letters, numbers, hyphens, and underscores'),
  
  state: yup
    .string()
    .min(2, 'State must be at least 2 characters')
    .max(50, 'State must be no more than 50 characters'),
  
  country: yup
    .string()
    .min(2, 'Country must be at least 2 characters')
    .max(100, 'Country must be no more than 100 characters'),
  
  city: yup
    .string()
    .max(100, 'City must be no more than 100 characters'),
  
  zip_code: yup
    .string()
    .matches(/^\d{5}(-\d{4})?$/, 'Please enter a valid zip code (e.g., 12345 or 12345-6789)')
    .max(10, 'Zip code must be no more than 10 characters'),
  
  superintendent: yup
    .string()
    .max(200, 'Superintendent name must be no more than 200 characters'),
  
  email: yup
    .string()
    .email('Please enter a valid email address')
    .max(100, 'Email must be no more than 100 characters'),
  
  phone: yup
    .string()
    .matches(/^[+]?[1-9]\d{0,15}$/, 'Please enter a valid phone number')
    .max(20, 'Phone number must be no more than 20 characters'),
  
  address: yup
    .string()
    .max(500, 'Address must be no more than 500 characters'),
  
  website: yup
    .string()
    .url('Please enter a valid website URL')
    .max(255, 'Website URL must be no more than 255 characters'),
});

// Types are now imported from types/index.ts
